import Vue from 'vue';
import Vuex from 'vuex';

import channels from './modules/channels';
import likes from './modules/likes';
import mgp from './modules/mgp';
import playlist from './modules/playlist';
import hitlist from './modules/hitlist';
import program from './modules/program';
import radioplayer from './modules/radioplayer';
import stations from './modules/stations';
import user from './modules/user';
import app from './modules/app';
import omnystudio from './modules/omnystudio';
import trackingPlugin from './plugins/tracking';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    channels,
    likes,
    mgp,
    playlist,
    hitlist,
    program,
    radioplayer,
    stations,
    user,
    app,
    omnystudio
  },
  plugins: [
    trackingPlugin
  ]
})
